<template>
  <div class="page">
    <div class="container">
      <div class="row">
        <div class="col">
          <hr />
          <h3>Calendar</h3>
          <div class="responsiveCal">
            <iframe
              src="https://calendar.google.com/calendar/embed?showTitle=0&amp;showDate=0&amp;showPrint=0&amp;showCalendars=0&amp;showTz=0&amp;height=600&amp;wkst=2&amp;hl=nl&amp;bgcolor=%23FFFFFF&amp;src=example.be_cpkbjcpttgb5q0%40group.calendar.google.com&amp;color=%23ffcf03&amp;ctz=Europe%2FBrussels"
              style="border-width:0"
              width="800"
              height="600"
              frameborder="0"
              scrolling="no"
            ></iframe>
            <iframe
              src="https://calendar.google.com/calendar/embed?src=3mj88kcbku96mffev3lrp063qg%40group.calendar.google.com&ctz=America%2FChicago"
              style="border: 0"
              width="800"
              height="600"
              frameborder="0"
              scrolling="no"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Events",

  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
iframe {
  position: relative;
}

a,
:hover {
  color: white !important;
}
h3 {
  text-align: center;
  font-size: 32px;
  color: white;
}
hr {
  background-color: grey;
}
strong {
  font-size: 24px;
  color: white;
}
.page {
  background-image: url("../assets/screen-5.png");
  background-color: grey;
  color: white;
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: 50%;
  height: 100%;
  width: 100%;
  display: flex;
  animation: backgroundMove 120s ease-in-out infinite;
}
.col {
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
}
.page >>> .label-link:hover {
  color: white;
}
.responsiveCal {
  position: relative !important;
  padding-bottom: 75%;
  height: 0;
  overflow: hidden;
}
.responsiveCal iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
